import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin + "/admin",
  },
  cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: false },
};

let msalInstance = null;
let initialized  = false;

async function getInstance() {
  if (!msalInstance) msalInstance = new PublicClientApplication(msalConfig);
  if (!initialized) {
    await msalInstance.initialize();
    initialized = true;
  }
  return msalInstance;
}

export async function login() {
  const instance = await getInstance();
  await instance.loginRedirect({ scopes: ["openid", "profile", "email"] });
}

export async function logout() {
  const instance = await getInstance();
  await instance.logoutRedirect();
}

export async function getAccount() {
  const instance = await getInstance();
  await instance.handleRedirectPromise();
  const accounts = instance.getAllAccounts();
  return accounts.length > 0 ? accounts[0] : null;
}

export async function getAccessToken() {
  const instance = await getInstance();
  const account  = await getAccount();
  if (!account) return null;
  try {
    const result = await instance.acquireTokenSilent({
      scopes: ["openid", "profile", "email"],
      account,
    });
    return result.accessToken;
  } catch {
    await instance.acquireTokenRedirect({ scopes: ["openid", "profile", "email"], account });
    return null;
  }
}
